var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyAudits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "141px",
    height: "120px",
    viewBox: "0 0 141 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Auditors",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.4-Current-audits-(empty)",
    transform: "translate(-695.000000, -368.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main",
    transform: "translate(106.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(279.000000, 352.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(310.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.416585,40.9756098 L139.519024,68.0692683 L138.879,68.7796098 L140.487805,68.7804878 L140.487805,111.219512 C140.487805,116.061951 136.549756,120 131.707317,120 L8.7804878,120 C3.93804878,120 0,116.061951 0,111.219512 L0,68.7804878 L1.608,68.7796098 L0.968780488,68.0692683 L31.0712195,40.9756098 L109.416585,40.9756098 Z M41.1995122,74.6341463 L5.85365854,74.6341463 L5.85365854,111.219512 C5.85365854,112.833659 7.16634146,114.146341 8.7804878,114.146341 L131.707317,114.146341 C133.321463,114.146341 134.634146,112.833659 134.634146,111.219512 L134.634146,74.6341463 L99.2882927,74.6341463 C97.8760976,83.7409756 89.982439,90.7317073 80.4878049,90.7317073 L60,90.7317073 C50.5053659,90.7317073 42.6117073,83.7409756 41.1995122,74.6341463 Z M107.16878,46.8292683 L33.3190244,46.8292683 L8.927,68.7796098 L46.8292683,68.7804878 L46.8292683,71.7073171 C46.8292683,78.9702439 52.7370732,84.8780488 60,84.8780488 L80.4878049,84.8780488 C87.7507317,84.8780488 93.6585366,78.9702439 93.6585366,71.7073171 L93.6585366,68.7804878 L131.56,68.7796098 L107.16878,46.8292683 Z",
    id: "Combined-Shape",
    fill: "#5F8298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5240976,2.82119956 L51.7681496,18.9189956 L46.8294179,22.0618248 L36.5853659,5.96402883 L41.5240976,2.82119956 Z M99.51322,2.8165898 L104.451952,5.95883371 L94.2098077,22.0566297 L89.271076,18.9143858 L99.51322,2.8165898 Z M72.7134894,-3.24943324e-14 L72.7134894,19.0243902 L66.8598309,19.0243902 L66.8598309,-3.24943324e-14 L72.7134894,-3.24943324e-14 Z",
    id: "Combined-Shape",
    fill: "#EE485F"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAudits);
export default __webpack_public_path__ + "static/media/empty-audits.0839158ce34e2943a456fd690383982c.svg";
export { ForwardRef as ReactComponent };